import React from 'react';
import { Outlet } from 'react-router-dom';

const CommunityViewRoot = () => {
  return <Outlet />;
};

export default CommunityViewRoot;
